import { ReactNode } from "react";
import styles from "./event-setup-review.module.scss";

export type ReviewField = {
  label: string;
  value: ReactNode;
  /** Spans full row (both columns) */
  fullWidth?: boolean;
};

type Props = {
  fields: ReviewField[];
  /** One label/value pair per row (for policies and long text fields). */
  onePerRow?: boolean;
  /** Sets labels to a dark, high-contrast color instead of the default muted grey. */
  darkLabels?: boolean;
};

const ReviewFieldGrid = ({ fields, onePerRow, darkLabels }: Props) => {
  return (
    <div
      className={
        onePerRow
          ? `${styles.reviewGrid} ${styles.reviewGridOnePerRow}`
          : styles.reviewGrid
      }
    >
      {fields.map((field, index) => (
        <div
          key={`${field.label}-${index}`}
          className={
            onePerRow || field.fullWidth
              ? `${styles.reviewGridCell} ${styles.reviewGridCellFull}`
              : styles.reviewGridCell
          }
        >
          <div
            className={styles.reviewGridLabel}
            style={darkLabels ? { color: "#262626", fontWeight: 500 } : undefined}
          >
            {field.label}
          </div>
          <div className={styles.reviewGridValue}>{field.value}</div>
        </div>
      ))}
    </div>
  );
};

export default ReviewFieldGrid;
